// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { CareOrderType } from './order-type/CareOrderType';
import { LimitOrderType } from './order-type/LimitOrderType';
import { MarketOrderType } from './order-type/MarketOrderType';
import { OCOOrderType } from './order-type/OCOOrderType';
import { StopLimitOrderType } from './order-type/StopLimitOrderType';
import { StopOrderType } from './order-type/StopOrderType';
import { TrailingStopOrderType } from './order-type/TrailingStopOrderType';
// класс который содержит в себе дополнительные параметры ордeра
export class OrderParamsContainer {
    constructor() {
        this.OrderTypes = {};
        this.AddOrderType(new MarketOrderType());
        this.AddOrderType(new LimitOrderType());
        this.AddOrderType(new StopOrderType());
        this.AddOrderType(new StopLimitOrderType());
        this.AddOrderType(new TrailingStopOrderType());
        this.AddOrderType(new CareOrderType());
        this.AddOrderType(new OCOOrderType());
    }
    AddOrderType(orderType) {
        this.OrderTypes[orderType.id()] = orderType;
    }
    // TODO. OrderExecutor's constants dependent.
    GetOrderType(id) {
        return this.OrderTypes[id];
    }
}
